import { createAsyncThunk } from '@reduxjs/toolkit';
import ChatterService from '../../../api/services/ChatterService';
import { CRM_ORGANIZATION_MEMBER_ROLE } from '../../../utils/constants';

export const changePassword = createAsyncThunk('chatter/changePassword', async requestData => {
  return await ChatterService.changePassword(requestData);
});

export const fetchInfluencerInfo = createAsyncThunk('chatter/fetchInfluencerInfo', async requestData => {
  return await ChatterService.fetchInfluencerInfo(requestData);
});

export const fetchInfluencerById = createAsyncThunk('chatter/fetchInfluencerById', async requestData => {
  return await ChatterService.fetchInfluencerById(requestData);
});

export const generateInfluencerPersonality = createAsyncThunk(
  'chatter/generateInfluencerPersonality',
  async requestData => {
    return await ChatterService.generateInfluencerPersonality(requestData);
  },
);

export const uploadInfluencerVoice = createAsyncThunk('chatter/uploadInfluencerVoice', async requestData => {
  return await ChatterService.uploadInfluencerVoice(requestData);
});

export const testInfluencerVoice = createAsyncThunk('chatter/testInfluencerVoice', async requestData => {
  return await ChatterService.testInfluencerVoice(requestData);
});

export const saveInfluencerVoice = createAsyncThunk('chatter/saveInfluencerVoice', async requestData => {
  return await ChatterService.saveInfluencerVoice(requestData);
});

export const editInfluencerPricing = createAsyncThunk('chatter/editInfluencerPricing', async requestData => {
  return await ChatterService.editInfluencerPricing(requestData);
});

export const uploadInfluencerQuestionnaire = createAsyncThunk(
  'chatter/uploadInfluencerQuestionnaire',
  async requestData => {
    return await ChatterService.uploadInfluencerQuestionnaire(requestData);
  },
);

// Same request as fetchInfluencerById, but only refreshes facts status (no page loading state)
export const refreshInfluencerFactsStatus = createAsyncThunk(
  'chatter/refreshInfluencerFactsStatus',
  async requestData => {
    return await ChatterService.fetchInfluencerById(requestData);
  },
);

export const fetchOrganizationMembersInfo = createAsyncThunk(
  'chatter/fetchOrganizationMembersInfo',
  async requestData => {
    return await ChatterService.fetchOrganizationMembersInfo(requestData);
  },
);

export const fetchAllOrganizationInfluencers = createAsyncThunk('chatter/fetchAllOrganizationInfluencers', async () => {
  return await ChatterService.fetchAllOrganizationInfluencers();
});

export const createOrganizationMember = createAsyncThunk('chatter/createOrganizationMember', async requestData => {
  return await ChatterService.createOrganizationMember(requestData);
});

export const fetchAllOrganizationChatters = createAsyncThunk('chatter/fetchAllOrganizationChatters', async () => {
  return await ChatterService.fetchAllOrganizationChatters();
});

export const fetchAllOrganizationTeamLeads = createAsyncThunk(
  'chatter/fetchAllOrganizationTeamLeads',
  async () => {
    return await ChatterService.fetchAllOrganizationTeamLeads();
  },
  {
    condition: (_, { getState }) => {
      return [CRM_ORGANIZATION_MEMBER_ROLE.OWNER, CRM_ORGANIZATION_MEMBER_ROLE.ADMINISTRATOR].includes(
        getState().userInfo.user?.role,
      );
    },
  },
);

export const deleteOrganizationMember = createAsyncThunk('chatter/deleteOrganizationMember', async requestData => {
  return await ChatterService.deleteOrganizationMember(requestData);
});

export const getOrganizationMemberById = createAsyncThunk('chatter/getOrganizationMemberById', async requestData => {
  return await ChatterService.getOrganizationMemberById(requestData);
});

export const editOrganizationMember = createAsyncThunk('chatter/editOrganizationMember', async requestData => {
  return await ChatterService.editOrganizationMember(requestData);
});

export const createReview = createAsyncThunk('chatter/createReview', async requestData => {
  return await ChatterService.createReview(requestData);
});

export const fetchReviews = createAsyncThunk('chatter/fetchReviews', async () => {
  return await ChatterService.fetchReviews();
});

export const fetchReviewById = createAsyncThunk('chatter/fetchReviewById', async (requestData, { getState }) => {
  const result = await ChatterService.fetchReviewById(requestData);
  const isReviewer = getState().userInfo?.user?.role === CRM_ORGANIZATION_MEMBER_ROLE.REVIEWER;
  return { ...result, isReviewer };
});
